export default [
  {
    name: "approvals",
    path: "/mall/approvals",
    component: (resolve) => require(["./approvals.vue"], resolve),
  },
  {
    name: "flightBooking",
    path: "/mall/flight/booking",
    meta: {
      requiresAuth: true,
    },
    component: (resolve) => require(["./flight/booking.vue"], resolve),
  },
  {
    name: "flightList",
    path: "/mall/flight/list",
    component: (resolve) => require(["./flight/list.vue"], resolve),
  },
  {
    name: "demand",
    path: "/mall/:service/demand",
    component: (resolve) => require(["./modules/demand.vue"], resolve),
  },
  {
    path: "/mall/flight/detail",
    component: (resolve) => require(["./flight/detail.vue"], resolve),
  },
  {
    name: "orderFill",
    path: "/mall/:state/orderFill",
    component: (resolve) => require(["./modules/orderFill.vue"], resolve),
  },
  {
    name: "hotelBooking",
    path: "/mall/hotel/booking",
    meta: {
      requiresAuth: true,
    },
    component: (resolve) => require(["./hotel/booking.vue"], resolve),
  },
  {
    path: "/mall/hotel/list",
    component: (resolve) => require(["./hotel/list.vue"], resolve),
  },
  {
    name: "hotelDetail",
    path: "/mall/hotel/detail",
    component: (resolve) => require(["./hotel/detail.vue"], resolve),
  },
  {
    path: "/mall/hotel/facility",
    component: (resolve) => require(["./hotel/facility.vue"], resolve),
  },
  {
    path: "/mall/hotel/map",
    component: (resolve) => require(["./hotel/map.vue"], resolve),
  },

  {
    name: "trainBooking",
    path: "/mall/train/booking",
    meta: {
      requiresAuth: true,
    },
    component: (resolve) => require(["./train/booking.vue"], resolve),
  },
  {
    path: "/mall/train/list",
    component: (resolve) => require(["./train/list.vue"], resolve),
  },
  {
    path: "/mall/train/detail",
    component: (resolve) => require(["./train/detail.vue"], resolve),
  },

  {
    name: "tourBooking",
    path: "/mall/tour/booking",
    meta: {
      requiresAuth: true,
    },
    component: (resolve) => require(["./tour/booking.vue"], resolve),
  },

  {
    // name: 'addTraveler',
    path: "/mall/addTraveller",
    component: (resolve) => require(["./user/addTraveller.vue"], resolve),
  },
  {
    path: "/mall/oftenPassenger",
    component: (resolve) => require(["./user/oftenPassenger.vue"], resolve),
  },
  {
    path: "/system/oftenPassenger",
    component: (resolve) => require(["./user/oftenPassenger.vue"], resolve),
  },
  {
    path: "/mall/AddTemporaryGuest",
    component: (resolve) => require(["./user/AddTemporaryGuest.vue"], resolve),
  },
  {
    name: "contacts",
    path: "/mall/contacts",
    component: (resolve) => require(["./user/contacts.vue"], resolve),
  },
  {
    path: "/system/contacts",
    component: (resolve) => require(["./user/contacts.vue"], resolve),
  },
  {
    path: "/system/address",
    component: (resolve) => require(["./user/address.vue"], resolve),
  },
  {
    path: "/mall/address",
    component: (resolve) => require(["./user/address.vue"], resolve),
  },
  {
    path: "/mall/addContact",
    component: (resolve) => require(["./user/addContact.vue"], resolve),
  },
  {
    path: "/mall/invoice",
    component: (resolve) => require(["./user/invoice.vue"], resolve),
  },
  {
    path: "/system/invoice",
    component: (resolve) => require(["./user/invoice.vue"], resolve),
  },
  {
    path: "/mall/addInvoice",
    component: (resolve) => require(["./user/addInvoice.vue"], resolve),
  },
  {
    path: "/mall/specialRequirement",
    component: (resolve) =>
      require(["./modules/specialRequirement.vue"], resolve),
  },
  {
    name: "NewAddress",
    path: "/mall/NewAddress",
    component: (resolve) => require(["./user/NewAddress.vue"], resolve),
  },
  {
    name: "selectTraveller",
    path: "/mall/selectTraveller",
    component: (resolve) => require(["./modules/selectTraveller.vue"], resolve),
  },
  {
    name: "DeviceInfo",
    path: "/DeviceInfo",
    component: (resolve) => require(["./DeviceInfo.vue"], resolve),
  },
];



// WEBPACK FOOTER //
// ./src/views/mall/router.js